<div class="col-sm-12">
  <h4>Imagenes Pendientes por Retocar</h4>
</div>
<div class="row">
  <div class="col-sm-4 mt-3 mb-3" *ngIf="multiselect && selected.length > 0">
    <button class="btn btn-danger btn-block" (click)="rejectmultipleimages()">Rechazar {{selected.length}} imagenes
    </button>
  </div>
  <div class="col-sm-4 mt-3 mb-3" *ngIf="multiselect && selected.length > 0">
    <button class="btn btn-info btn-block" (click)="approveDownload()">Aprobar y descargar {{selected.length}} imagenes</button>
  </div>
  <div class="col-sm-4 mt-3 mb-3" *ngIf="multiselect && selected.length > 0">
    <button class="btn btn-success btn-block" (click)="approvedAll()">Aprobar {{selected.length}} imagenes</button>
  </div>
</div>
<div class="row">
  <div class="col-sm-10">
    <div class="d-flex flex-wrap ">
      <div *ngFor="let item of data;let i = index">
        <div class="card text-white p-2 m-2 border-none" [ngClass]="{'bg-primary': multiselect == true}">
          <div class="card-header m-0 p-1 border-none" style="max-width: 10vw;" *ngIf="multiselect"
            [ngClass]="{'bg-danger': selected.includes(item)}">
            <button class="btn btn-primary btn-circle btn-sm" (click)="seleccionar(item)"
              *ngIf="!selected.includes(item)">
              <i class="far fa-check-circle"></i>
            </button>
            <button class="btn btn-light btn-circle btn-sm" (click)="descheck(item)" *ngIf="selected.includes(item)">
              <i class="fas fa-times-circle"></i>
            </button>
          </div>
          <div style="z-index: 100;cursor: pointer; " (click)="change()">
            <app-image-container img="{{item.url}}" tipe="original"></app-image-container>
          </div>
          <div class="d-flex flex-wrap justify-content-around" style="padding: 5px;z-index: 150; " *ngIf="!multiselect">
            <button class="btn btn-success btn-circle btn-sm" (click)="approved(item)">
              <i class="fas fa-check"></i>
            </button>
            <button class="btn btn-danger btn-circle btn-sm" (click)="rejectphoto(item)">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-2">
    <h4 class="text-center">Retoques</h4>
    <div class="p-2 text-center">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let item of specs.retoques">{{item}}</li>
      </ul>
    </div>

  </div>

</div>


<app-modal-loading [show]="modal_loading"></app-modal-loading>

<app-modal-success [show]="modal_success" [data]="fileData" [tipe]="tipe"  [id]="id"></app-modal-success>

<app-reject-image [show]="modal_reject" [data]="fileData" [tipe]="tipe" ></app-reject-image>

<!-- <app-modal-image [image]="imageUrl"  [show]="show"></app-modal-image> -->
